const pagesSettingsSettingsEn = {
  authentication: {
    mfa: {
      card: {
        edit: 'Edit',
        notRequired: 'Optional',
        required: 'Required',
        title: 'MFA Enforcement'
      },
      deleteDialog: {
        continueButton: 'Continue',
        description: 'Affected accounts will be able to sign in without an additional identity check',
        discardChangesButton: 'Discard changes',
        title: 'Remove the MFA Requirement?'
      },
      description: 'Adds one more identity check at sign-in',
      editDialog: {
        cancelButton: 'Cancel',
        error: 'An error occurred while saving changes. Please try again',
        saveButton: 'Save',
        title: 'MFA Enforcement'
      },
      mfaMethod: {
        email: 'Email'
      },
      title: 'MFA',
      userType: {
        individual: 'Individual',
        operator: 'Staff'
      }
    },
    title: 'Authentication Policy'
  },
  loginEmailPolicy: {
    card: {
      edit: 'Edit',
      title: 'Personal Email Login Restriction'
    },
    description: 'Configure whether personal email addresses can be used for login, per account type',
    editDialog: {
      cancelButton: 'Cancel',
      error: 'An error occurred while saving changes. Please try again',
      saveButton: 'Save',
      title: 'Personal Email Login Restriction'
    },
    loadError: 'Could not load',
    mode: {
      alwaysAllowed: {
        label: 'Not Restricted'
      },
      disallowed: {
        label: 'Always Restricted'
      },
      untilWorkEmailSet: {
        label: 'Restricted once employee email is set'
      }
    },
    retry: 'Retry',
    target: {
      individual: 'Individual',
      operator: 'Staff'
    },
    title: 'Personal Email Login',
    toast: {
      updateSuccess: 'Settings updated'
    }
  },
  loginMethodPolicy: {
    card: {
      edit: 'Edit',
      title: 'SSO Login Enforcement'
    },
    description: 'Require SSO login, per account type',
    editDialog: {
      cancelButton: 'Cancel',
      description: 'Set an enforcement date to allow a migration period',
      saveButton: 'Save',
      title: 'SSO Login Enforcement'
    },
    enforce: {
      datePlaceholder: 'Select a date',
      now: 'Enforced now',
      off: 'Optional',
      scheduled: 'Enforced from a specific date'
    },
    loadError: 'Could not load',
    retry: 'Retry',
    summary: {
      enforceFromFuture: {
        hint: 'Password login is available until then',
        value: 'Enforced from {{dateTime}}'
      },
      enforcedNow: {
        value: 'Enforced'
      },
      notRequired: {
        value: 'Optional'
      }
    },
    target: {
      individual: 'Individual',
      operator: 'Staff'
    },
    title: 'SSO Login',
    toast: {
      updateSuccess: 'Settings updated'
    }
  },
  sso: {
    active: 'Enabled',
    addConnection: 'Add Connection',
    card: {
      domains: 'Target domains',
      providers: 'Inbound SSO',
      status: 'Status'
    },
    deleteDialog: {
      cancelButton: 'Cancel',
      deleteButton: 'Disconnect',
      description: 'Domain settings will also be removed, and affected users will no longer be able to sign in via SSO',
      title: 'Disconnect this provider?'
    },
    description: "Let users sign in to DRESS CODE with your organization's identity provider",
    disconnect: 'Disconnect',
    edit: 'Edit',
    editDialog: {
      addDomain: 'Add domain',
      cancelButton: 'Cancel',
      domainPlaceholder: 'e.g. acme.com',
      domainsDescription: 'Specify the email domains for users who will sign in via SSO',
      domainsLabel: 'Target domains',
      enabledLabel: 'Enabled',
      removeDomainAriaLabel: 'Remove {{domain}}',
      saveButton: 'Save',
      title: 'Inbound SSO: {{provider}}',
      titleConnect: 'Add Connection: {{provider}}'
    },
    loadError: 'Could not load',
    noDomains: 'Not configured',
    notConnected: 'Not Connected',
    openMenu: 'Open menu',
    paused: 'Paused',
    retry: 'Retry',
    title: 'Inbound SSO',
    toast: {
      deleteSuccess: 'Provider disconnected',
      saveSuccess: 'SSO connection saved'
    },
    validation: {
      duplicateDomain: 'This domain is already added',
      invalidDomain: 'Please enter a valid domain format',
      issuerIdentifierRequired: 'This field is required'
    }
  }
};
export default pagesSettingsSettingsEn;